import React, { useState, useEffect } from 'react';
import { Alert, Container, Spinner } from '@themesberg/react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInfoCircle, faTimes } from '@fortawesome/free-solid-svg-icons';
import { useCookies } from 'react-cookie';
import { getAll, markAsRead } from '../controller/api/notificationSystem';

export default () => {
  const [notifications, setNotifications] = useState([]);
  const [cookies] = useCookies(['lottmekong']);
  const [loading, setLoading] = useState(true);
  const [dismissingNotifications, setDismissingNotifications] = useState(new Set());

  useEffect(() => {
    const fetchNotifications = async () => {
      try {
        setLoading(true);
        const response = await getAll(cookies.lottmekong);
        
        if (response && response.data) {
          // Keep the timeline short to avoid pushing the content too far down
          setNotifications(response.data.slice(0, 4));
        } else {
          setNotifications([]);
        }
      } catch (error) {
        console.error('Error fetching system notifications:', error);
        setNotifications([]);
      } finally {
        setLoading(false);
      }
    };

    if (cookies.lottmekong) {
      fetchNotifications();
    } else {
      setLoading(false);
    }
  }, [cookies.lottmekong]);

  if (loading) {
    return null; // Or you could return a loading spinner
  }

  const handleDismiss = async (notificationId) => {
    try {
      // Add to dismissing state to show loading
      setDismissingNotifications(prev => new Set([...prev, notificationId]));
      
      // Call API to mark as read
      await markAsRead(cookies.lottmekong, notificationId);
      
      // Remove from notifications list after successful API call
      setNotifications(prev => prev.filter(n => n.id !== notificationId));
      
      // Remove from dismissing state after successful removal
      setDismissingNotifications(prev => {
        const newSet = new Set(prev);
        newSet.delete(notificationId);
        return newSet;
      });
    } catch (error) {
      console.error('Error marking notification as read:', error);
      // Remove from dismissing state if failed
      setDismissingNotifications(prev => {
        const newSet = new Set(prev);
        newSet.delete(notificationId);
        return newSet;
      });
    }
  };

  if (!notifications || notifications.length === 0) {
    return null;
  }

  return (
    <Container fluid className="px-3 py-2" style={{ maxWidth: '800px', margin: '0 auto' }}>
      <div className="system-notification-banner">
        {notifications.map((notification, index) => {
          const isDismissing = dismissingNotifications.has(notification.id);
          return (
          <Alert 
            key={notification.id || index} 
            variant="info" 
            className="mb-1 d-flex align-items-center py-2 px-3"
            style={{
              borderLeft: '3px solid #0d6efd',
              boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
              fontSize: '0.875rem'
            }}
          >
            <FontAwesomeIcon icon={faInfoCircle} className="me-2" style={{ fontSize: '1rem' }} />
            <div className="flex-grow-1" style={{ minWidth: 0 }}>
              {notification.title && (
                <strong className="d-block" style={{ fontSize: '0.875rem', marginBottom: '2px' }}>
                  {notification.title}
                </strong>
              )}
              {notification.message && (
                <span style={{ fontSize: '0.813rem' }}>{notification.message}</span>
              )}
            </div>
            <button
              onClick={() => handleDismiss(notification.id)}
              disabled={isDismissing}
              style={{
                background: 'none',
                border: 'none',
                padding: '0 0 0 10px',
                cursor: isDismissing ? 'not-allowed' : 'pointer',
                color: '#6c757d',
                fontSize: '1rem',
                lineHeight: 1,
                flexShrink: 0,
                opacity: isDismissing ? 0.5 : 1
              }}
              aria-label="Đóng"
            >
              {isDismissing ? (
                <Spinner animation="border" size="sm" style={{ width: '14px', height: '14px' }} />
              ) : (
                <FontAwesomeIcon icon={faTimes} />
              )}
            </button>
          </Alert>
        );
        })}
      </div>
    </Container>
  );
};
